import { render } from "./location-btn.vue?vue&type=template&id=ca3976fa&scoped=true&ts=true"
import script from "./location-btn.vue?vue&type=script&lang=ts"
export * from "./location-btn.vue?vue&type=script&lang=ts"

import "./location-btn.vue?vue&type=style&index=0&id=ca3976fa&lang=scss&scoped=true"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca3976fa"]])

export default __exports__